import React from 'react';

export function Education() {
  return (
    <div className="education">
      <section>Образование: высшее техническое</section>
      <section>
        Университет: Белорусский Государственный Аграрный Технический
        Университет
      </section>
      <section>Факультет: Агроэнергетический</section>
      <section>Специальность: инженер</section>
      <section>
        Во время учебы активно интересовался информатикой, информационными
        технологиями, хорошо освоил Microsoft Word, Microsoft Excel, AutoCAD.
        Был опыт работы с базами данных SQL.
      </section>
      <section>Проходил курсы HTML Academy, интенсивы по PHP.</section>
    </div>
  );
}
